
import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { useNavigate, useParams } from "react-router-dom";
import axios from "../axiosInstance";
import Topbar from "../components/topbar";
import Pagination from "../components/Pagination";
export default function Collections() {
    const [view, setView] = useState(false);
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [ListCollections, setListCollections] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [theDate, setTheDate] = useState("");
    const [theDate2, setTheDate2] = useState("");
    let header =
    {
        'Content-Type': 'application/json'
    };
    const viewClose = () => {
        setView(false)
    }
    const viewOpen = () => {
        setView(true)
    }
    

    const bUrl =process.env.REACT_APP_B_URL;
    const { idAgent } = useParams();
    const { idAgency } = useParams();
    

    const navigate = useNavigate();
    const getListCollections = async (theDate,theDate2) => {
        let url="/collect?page="+currentPage+"&limit=10";
    if(idAgent!=undefined){
        url="/collect/findWithAgentOrAgency?fkIdAgent="+idAgent+"&page="+currentPage+"&limit=10";
    }
    if(idAgency!=undefined){
        url="/collect/findWithAgentOrAgency?fkIdAgency="+idAgency+"&page="+currentPage+"&limit=10";
    }
        let formattedToday="";
        
        if(theDate!="" && theDate!=undefined && theDate2!=undefined ){
            
            let tt=theDate.split("-");
            formattedToday = tt[0]+ '-'+ tt[1] + '-' + tt[2] ;//value="2013-01-08"
            setTheDate(formattedToday);
            let tt2=theDate2.split("-");
            let formattedToday2 = tt2[0]+ '-'+ tt2[1] + '-' + tt2[2] ;
            setTheDate2(formattedToday2);
            url="/collect/withDate?beginDate="+formattedToday+"&endDate="+formattedToday2+"&page="+currentPage+"&limit=10";
        }
        
        const response = await axios.get(bUrl + url).catch((err) => {
            console.log(err);
            setIsLoading(false)

        });
        if (response) {
            if(response.status==401){
                navigate('/backoffice/login');
            }
            setListCollections(response.data.body);
            setTotalPage(response.data.totalPage)
            setIsLoading(false);
            console.log(response.data)
        }
    }
    const postCutomers = async () => {

    }
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric",hour: 'numeric', minute: 'numeric', second: 'numeric'}
        return new Date(dateString).toLocaleDateString(undefined, options)
      }
    useEffect(() => {
        if(sessionStorage.getItem("aname")==='' ||sessionStorage.getItem("name")===null){
            //console.log("----------GO GO GO ------------")
            navigate('/backoffice/login');
          }
        getListCollections(theDate,theDate2);
    }, [currentPage])

    return (
        <div className="App">
            <div className="">


                <Sidebar />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <Topbar/>
                        <div className="table-content mt-3 p-3">
                            <div className="d-flex justify-content-around">
                            <div className="form-group text">
                                <label htmlFor="exampleInputEmail1">Begin Date</label>
                                <input type="Date" onChange={(e)=>getListCollections(e.target.value,theDate2)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email"/>
                            </div>
                            <div className="form-group text">
                                <label htmlFor="End Date">End date</label>
                                <input type="Date" onChange={(e)=>getListCollections(theDate,e.target.value)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone"/>
                            </div>
                           
                            </div>
                        </div>
                        <div className="table-content mt-3 p-3">


<button onClick={() => viewOpen()}>

    <i className='fa fa-plus-circle'></i>
</button>
{/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
<div className="table-responsive-xl">
{isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
    <table className="table text">
        <thead>
            <tr>

                <th scope="col">Id</th>
                <th scope="col">Agent</th>
                <th scope="col">Agency</th>
                <th scope="col">City</th>
                <th scope="col">Localistation</th>
                

                
                <th scope="col">Date</th>
                
                
                
                <th></th>
                <th></th>

            </tr>
        </thead>

        <tbody>
            {ListCollections.length > 0 ? ListCollections.map((a, i) => {
                return <tr>
                    <td>{i}</td>
                    <td>{a.agent!=null? a.agent.firstName+" "+a.agent.middleName+" "+a.agent.lastName:""}</td>
                    <td>{a.agency!=null?a.agency.code:""}</td>
                    
                    <td>{a.city}</td>
                    <td>{a.lat!=null |a.lat==""?a.lat +"/" +a.lng:""}</td>
                    
                    
                    <td>{formatDate(a.updatedDate) }</td>

                </tr>
            }) : <tr></tr>}
        </tbody>

    </table>
    
}
<Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />


</div>
</div>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
